export const devEnv = 'https://stage-buildachair.netlify.app';
export const prodEnv = 'https://buildachair.netlify.app';
export const REACT_NATIVE_API = process.env.NODE_ENV === 'development' ? 'http://v1.localhost' : 'https://api.ecomseating.com';
export const REACT_NATIVE_APIV2 = process.env.NODE_ENV === 'development' ? 'http://v2.localhost' : 'https://apiv2.ecomseating.com';
// export const REACT_NATIVE_APIV2 = 'https://stage.apiv2.ecomseating.com'
